<app-button
  type="secondary" (click)="buttonClick()"
  [icon]="{ name: 'arrow-right', position: 'right' }" 
  position="left"
  class="ion-margin-top">
  {{ node?.label }}
</app-button>